// Move menu drawer out of the header stacking context so it renders above the sticky header
(function () {
  function relocateMenuDrawer() {
    var drawer = document.getElementById('menuDrawer');
    if (drawer && drawer.parentElement && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateMenuDrawer);
  } else {
    relocateMenuDrawer();
  }
})();

// HÄDDEN Quick Add — adds to cart then opens the cart drawer
window.haddenQuickAdd = async function (btn) {
  var productUrl = btn.dataset.productUrl || '';
  var baseUrl = productUrl.split('?')[0];
  if (!baseUrl) return;

  btn.disabled = true;

  try {
    // Get product JSON to check variant count
    var product = await fetch(baseUrl + '.js').then(function (r) { return r.json(); });

    // Multi-variant — open quick shop modal so customer can pick options
    if (product.variants.length > 1) {
      window.dialogQuickShop.showModal(btn);
      return;
    }

    var variantId = product.variants[0].id;

    // Add to cart — request the cart-drawer section HTML in the same response
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    var cartResponse = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    }).then(function (r) { return r.json(); });

    // Sold out or other error — fall back to the quick-shop modal
    if (cartResponse.status) {
      window.dialogQuickShop.showModal(btn);
      return;
    }

    // Update only the .js-cart-drawer-wrapper innerHTML (not the whole section),
    // so the theme component's internal element references stay valid.
    // This matches what SHTCartDrawerForm.renderContents does internally.
    var cartDrawerContainer = document.getElementById('cartDrawer');
    if (cartDrawerContainer && cartResponse.sections && cartResponse.sections['cart-drawer']) {
      var parser = new DOMParser();
      var sectionDoc = parser.parseFromString(cartResponse.sections['cart-drawer'], 'text/html');
      var newWrapper = sectionDoc.querySelector('.js-cart-drawer-wrapper');
      var existingWrapper = cartDrawerContainer.querySelector('.js-cart-drawer-wrapper');
      if (newWrapper && existingWrapper) {
        existingWrapper.innerHTML = newWrapper.innerHTML;
      }
    }

    // Open the cart drawer
    var cartDrawer = document.querySelector('sht-cart-drwr');
    if (cartDrawer && cartDrawer.openDrawer) {
      cartDrawer.openDrawer(btn);
    }

  } catch (e) {
    console.error('Quick add error:', e);
    window.dialogQuickShop.showModal(btn);
  } finally {
    btn.disabled = false;
  }
};
